export const storeMixin = {
  methods: {
    setTicketData(fieldName, value) {
      this.$store.dispatch(
        'tenants/ticketTypes/storeData',
        {
          field: fieldName,
          value: value
        }
      )
    },
    setTabLang(lang) {
      this.$store.dispatch(
        'tenants/ticketTypes/setTabLang',
        {
          lang: lang
        }
      )
    },
    setTabName(event, lang) {
      this.$store.dispatch(
        'tenants/ticketTypes/storeName',
        {
          lang: lang,
          name: event.target.value
        }
      )
    },
    setTabDescription(event, lang) {
      this.$store.dispatch(
        'tenants/ticketTypes/storeDescription',
        {
          lang: lang,
          description: event.target.value
        }
      )
    }
  }
}





// WEBPACK FOOTER //
// ./src/components/tenants/ticket-types/mixins/storeMixin.js